import * as React from "react";
function SvgIcTableColumnNumericalHidden(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 3v4H7.625l-1.25-1H21V4H3.875l-1.248-.999L2.628 3H22zM2 18v4h7v-4H2zm6 3H3v-2h5v2zm-6-8v4h7v-4H2zm6 3H3v-2h5v2zm10.006-.781h.96l-.1.696 1.162.94.236-1.64H22v-1.286h-1.554L20.72 12h-1.299l-.276 1.929h-2.558L16.864 12h-1.299l-.16 1.114 2.601 2.105zM2.162 3.679l-.112.141L2 3.78v.103l-.438.546.438.35V7h2.776l1.25 1H2v4h7v-1.621l4.643 3.715v1.12h1.4l.056.044-.363 2.528H13v1.285h1.554L14.28 21h1.299l.276-1.929h2.558L18.136 21h1.299l.276-1.929h.154l1.438 1.151.509-.636L2.162 3.68zM3 6v-.42l.526.42H3zm5 5H3V9h4.276L8 9.579V11zm8.04 6.79l.229-1.596 1.995 1.596h-2.225z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTableColumnNumericalHidden;
